export default __webpack_public_path__ + "static/media/James McGovern.30e5e366.jpg";